import { useEffect, useState } from 'react';
import { useGetClients } from '@/home/application/adapters/getClients';
import { getUserIdFromSession } from '@/home/application/utils/sessionUtils';

export const useClients = () => {
  const [userID, setUserID] = useState<number | undefined>(undefined);
  const [isReady, setIsReady] = useState(false);

  // Get user ID from session storage on mount and when session storage changes
  useEffect(() => {
    const getUserID = () => {
      const id = getUserIdFromSession();
      console.log('Getting userID from session storage:', id);
      setUserID(id ?? undefined);
      setIsReady(true);
    };

    // Get userID immediately on mount
    getUserID();

    // Also listen for storage changes (in case login happens in another tab)
    const handleStorageChange = () => {
      getUserID();
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Call the API adapter with the userID
  const result = useGetClients(userID);

  return {
    ...result,
    isReady,
  };
};
